import { TutorAdminResponse } from "client/openapi";
import BookingProfileCard from "components/PublicBooking/BookingProfileCard";

/** What families see on the tutor's booking page, for admins to edit. */
export default function BookingPageTab({
  tutor,
}: {
  tutor: TutorAdminResponse;
}) {
  return (
    <BookingProfileCard
      tutorId={tutor.id}
      firstName={tutor.first_name}
      lastName={tutor.last_name}
      canHide
    />
  );
}
